import PiConfirmationDialog from "../../components/PiConfirmationDialog";
import type { PropReference } from "../../helpers/PropReferences";

export default function PropDeletionBlockedDialog({ references, onClose }: {
  references: PropReference[];
  onClose: () => void;
}) {
  return (
    <PiConfirmationDialog
      open={references.length > 0}
      onClose={onClose}
      title="Prop is still in use"
      text={
        <div>
          <p>Remove or replace these references before deleting this Prop.</p>
          <ul className="mt-3 max-h-[200px] overflow-y-auto list-disc pl-5">
            {references.map((reference, index) => <li key={index}>{reference.location}</li>)}
          </ul>
        </div>
      }
      onConfirm={onClose}
      confirmText="Close"
      cancelText=""
      confirmButtonVariant="piBlue"
      height="400px"
      hideCancelButton
    />
  );
}
